import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
export function CTABanner() {
  return <section className="py-20 bg-gradient-to-r from-blue-600 to-primary text-white text-center px-4" data-id="element-46">
      <div className="container mx-auto max-w-4xl" data-id="element-47">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-48">
          Need Urgent Delivery or Logistics Support?
        </h2>
        <p className="text-xl text-blue-100 mb-10" data-id="element-49">
          Contact Global Universal Logistics today for fast, reliable delivery
          solutions.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-50">
          <Link to="/quote" className="w-full sm:w-auto" data-id="element-51">
            <Button size="lg" className="w-full sm:w-auto bg-white text-primary hover:bg-slate-100 text-lg px-8" data-id="element-52">
              Get Quote
            </Button>
          </Link>
          <Link to="/contact" className="w-full sm:w-auto" data-id="element-53">
            <Button size="lg" className="w-full sm:w-auto bg-transparent border-2 border-white text-white hover:bg-white/10 text-lg px-8" data-id="element-54">
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}